import { apiRequest } from "./client";

export const projectsApi = {
  list() {
    return apiRequest("/projects");
  },

  inspectPendingStorefrontGatewayMigrations(params = {}) {
    return apiRequest("/projects/deployment/storefront-gateway/pending", { params });
  },

  migratePendingStorefrontGatewayBatch(payload = {}) {
    return apiRequest("/projects/deployment/storefront-gateway/pending", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  create(payload) {
    return apiRequest("/projects", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  get(projectId) {
    return apiRequest(`/projects/${projectId}`);
  },

  getReadiness(projectId) {
    return apiRequest(`/projects/${projectId}/readiness`);
  },

  markNavigationExplored(projectId, payload = {}) {
    return apiRequest(`/projects/${projectId}/navigation-learning`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  getDeployment(projectId) {
    return apiRequest(`/projects/${projectId}/deployment`);
  },

  listDeploymentJobs(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/deployment/jobs`, { params });
  },

  retryDeploymentJob(projectId, jobId) {
    return apiRequest(`/projects/${projectId}/deployment/jobs/${jobId}/retry`, {
      method: "POST",
      body: JSON.stringify({}),
    });
  },

  retryDeployment(projectId) {
    return apiRequest(`/projects/${projectId}/deployment/retry`, {
      method: "POST",
    });
  },

  migrateToSharedStorefront(projectId) {
    return apiRequest(`/projects/${projectId}/deployment/migrate-shared`, {
      method: "POST",
      body: JSON.stringify({}),
    });
  },

  migrateProjectToStorefrontGateway(projectId) {
    return apiRequest(`/projects/${projectId}/deployment/migrate-shared`, {
      method: "POST",
      body: JSON.stringify({ target: "gateway" }),
    });
  },

  migrateDomainsToSharedStorefront(projectId) {
    return apiRequest(`/projects/${projectId}/deployment/migrate-shared/domains`, {
      method: "POST",
      body: JSON.stringify({}),
    });
  },

  migrateDomainsToStorefrontGateway(projectId) {
    return apiRequest(`/projects/${projectId}/deployment/migrate-shared/domains`, {
      method: "POST",
      body: JSON.stringify({ target: "gateway" }),
    });
  },

  deleteLegacyRender(projectId) {
    return apiRequest(`/projects/${projectId}/deployment/legacy-render`, {
      method: "DELETE",
      body: JSON.stringify({}),
    });
  },

  requestDomain(projectId, payload) {
    return apiRequest(`/projects/${projectId}/domain`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  getDomain(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/domain`, { params });
  },

  getDomainEntitlement(projectId) {
    return apiRequest(`/projects/${projectId}/domain/entitlement`);
  },

  verifyDomain(projectId, payload = {}) {
    return apiRequest(`/projects/${projectId}/domain/verify`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  unlinkDomain(projectId, payload = {}) {
    return apiRequest(`/projects/${projectId}/domain`, {
      method: "DELETE",
      body: JSON.stringify(payload),
    });
  },

  update(projectId, payload) {
    return apiRequest(`/projects/${projectId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  updateCapabilities(projectId, capabilities) {
    return apiRequest(`/projects/${projectId}/capabilities`, {
      method: "PATCH",
      body: JSON.stringify({ capabilities }),
    });
  },

  updateBusinessConfiguration(projectId, payload = {}) {
    const body = {};
    if (Object.prototype.hasOwnProperty.call(payload, "businessProfile")) {
      body.businessProfile = payload.businessProfile ?? "";
    }
    if (Object.prototype.hasOwnProperty.call(payload, "businessGoals")) {
      body.businessGoals = Array.isArray(payload.businessGoals) ? payload.businessGoals : [];
    }
    if (Object.prototype.hasOwnProperty.call(payload, "capabilities")) {
      body.capabilities = payload.capabilities || {};
    }
    if (Object.prototype.hasOwnProperty.call(payload, "membershipSettings")) {
      body.membershipSettings = payload.membershipSettings || {};
    }
    return apiRequest(`/projects/${projectId}/capabilities`, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  },

  listMembers(projectId) {
    return apiRequest(`/projects/${projectId}/members`);
  },

  addMember(projectId, payload) {
    return apiRequest(`/projects/${projectId}/members`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateMember(projectId, memberId, payload) {
    return apiRequest(`/projects/${projectId}/members/${memberId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  removeMember(projectId, memberId) {
    return apiRequest(`/projects/${projectId}/members/${memberId}`, {
      method: "DELETE",
    });
  },
};
